module.exports = __webpack_public_path__ + "img/3-1.6ea2808c.svg";